<template>
    <v-app-bar
        v-if="!showingDrawer"
        density="compact"
        scroll-behavior="collapse"
        elevation="0"
    >
        <template v-slot:prepend>
            <v-app-bar-nav-icon
                @click="showingDrawer = !showingDrawer"
            />
        </template>
        <v-app-bar-title>
            EOD Vehículos
        </v-app-bar-title>
      
        <v-spacer/>

        <v-chip
            v-if="appStore.inOfflineMode"
            density="compact"
            prepend-icon="mdi-wifi-off"
            color="warning"
        >
            Sin Conexión
        </v-chip>
        <ThemeSwitcher/>
    </v-app-bar>

    <v-navigation-drawer
        v-model="showingDrawer"
        fixed
        width="300"
        mobile-breakpoint="md"
        :temporary="false"
    >
        <v-list class="h-100 d-flex flex-column" nav density="compact">
            <v-list-item title="EOD Vehículos" subtitle="Sistema de encuestas"/>
            <v-divider/>
            <v-list-item
                :active="isCurrentRoute(item.routeName)"
                v-for="item in menuItems"
                :key="item.title"
                :title="item.title"
                :prepend-icon="item.prependIcon"
                @click="goTo(item.routeName)"
                color="primary"
            />
            
            <v-divider></v-divider>

            <v-spacer/>

            <v-alert
                class="flex-0-0"
                v-if="appStore.inOfflineMode"
                density="compact"
                color="warning"
                variant="tonal"
                title="Modo sin conexión"
                border="start"
                text="La aplicación está trabajando sin conexión. Las encuestas realizadas se guardar en la memoria del dispositivo. Una vez se establezca nuevamente la conexión, se enviaran los datos al servidor.">
            </v-alert>
            
            <v-divider/>
            <v-list nav density="compact">
                <ThemeSwitcher as-list-item/>
                <v-list-item
                    v-for="item in menuFooterItems"
                    :active="isCurrentRoute(item.routeName)"
                    :key="item.title"
                    :title="item.title"
                    :prepend-icon="item.prependIcon"
                    @click="goTo(item.routeName)"
                    color="primary"
                    :disabled="item.disabled"
                    v-show="!item.onlyAdmin || currentUser?.isAdmin"
                />
            </v-list>
        </v-list>

    </v-navigation-drawer>
</template>

<script setup lang="ts">
import { useAppStore } from '@/stores/AppStore';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import ThemeSwitcher from './ThemeSwitcher.vue';
import { useDisplay } from 'vuetify';
import { AuthService, User } from "@/services/auth/authService"

const appStore = useAppStore();
const router = useRouter();

const display = useDisplay()
const showingDrawer = ref(!display.sm.value)

const authService = new AuthService()
const currentUser = ref<User>()

const menuItems = [
    { prependIcon: "mdi-plus", title: "Comenzar encuesta", routeName: "home" },
]

const menuFooterItems = [
    { prependIcon: "mdi-download", title: "Descargar resultados", routeName: "download-results", disabled: false, onlyAdmin: true },
    { prependIcon: "mdi-file", title: "Encuestas", routeName: "surveys", disabled: false, onlyAdmin: true },
    { prependIcon: "mdi-account", title: "Usuarios", routeName: "users", disabled: false, onlyAdmin: true },
    { prependIcon: "mdi-login", title: "Cerrar sesión", routeName: "login", disabled: false },
]

function isCurrentRoute(routeName: string) {
    return router.currentRoute.value.name === routeName;
}

function goTo(routeName: string) {
    router.push({name: routeName});
}

onMounted(() => {
    currentUser.value = authService.getCurrentUser() 
})

</script>

<style lang="scss" scoped>
</style>
